module.exports = __webpack_public_path__ + "img/parkTavor.851ed11d.png";